import { Button, DatePicker, Form, Select, Skeleton, Steps } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ekomerchantOnboard } from "./EkoEndpoint";
import { setselectedTab } from "../../../Store/B2bslice";
import { dispatchtoast, getLocalStorageItem, panPattern } from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";

const DoMerchantOnboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const handleSubmit = (val) => {
    const formattedData = {
      ...val,
      dob: dayjs(val.dob).format("YYYY-MM-DD"),
      latitude: getLocalStorageItem("latitude"),
      longitude: getLocalStorageItem("longitude"),
    };

    const formdata = new FormData();
    Object.entries(formattedData).forEach(([key, value]) => {
      formdata.append(key, value);
    });
    setBtnLoading(true);
    console.log(formattedData);
    ekomerchantOnboard(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          setOpenOtpModal(true);
          if (memberServices.includes("114")) {
            navigate("/eko/aeps-service");
          } else {
            navigate("/eko/payout");
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBtnLoading(false);
      });
  };

  useEffect(() => {
    dispatch(setselectedTab("300"));
  }, []);
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <div className="flex justify-start items-center">
            <p className="text-[15px] font-bold ">Merchant Onboarding</p>
          </div>
          <Form
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleSubmit(val)}
          >
            <Form.Item
              name={`first_name`}
              label={"First Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter First Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your Namer" name="first_name" />
            </Form.Item>
            <Form.Item
              name={`last_name`}
              label={"Last Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Last Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your Namer" name="last_name" />
            </Form.Item>
            <Form.Item
              name={`line`}
              label={"Line"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Line!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your Line Number" name="line" />
            </Form.Item>
            <Form.Item
              name={`city`}
              label={"City"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter city!",
                },

                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your city" name="city" />
            </Form.Item>
            <Form.Item
              name={`pan_number`}
              label={"Pan Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Pan Number!",
                },
                {
                  pattern: panPattern,
                  message: "Invalid pan number format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Pan Number"
                name="pan_number"
                onInput={(e) => {
                  const value = e.target.value.toUpperCase();
                  e.target.value = value;
                }}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`state`}
              label={"State"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter State!",
                },
              ]}
            >
              <CommonInput
                className="w-full"
                placeholder="Enter State"
                name="state"
              />
            </Form.Item>
            <Form.Item
              name={`dob`}
              label={"Dob"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter dob!",
                },
              ]}
            >
              <DatePicker
                className="w-full"
                placeholder="Enter dob"
                name="dob"
              />
            </Form.Item>
            <Form.Item
              name={`pincode`}
              label={"Pincode"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter pincode!",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your Pincode" name="pincode" />
            </Form.Item>
            <Form.Item
              name={`district`}
              label={"District"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter District!",
                },
              ]}
            >
              <CommonInput
                placeholder="District"
                // className="w-full mt-2"
                // options={deviceOptions}
              />
            </Form.Item>
            <Form.Item
              name={`area`}
              label={"area"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter area!",
                },
              ]}
            >
              <CommonInput
                placeholder="area"
                // className="w-full mt-2"
                // options={deviceOptions}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Send
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      {/* {openOtpModal && (
        <YesValidateOtpModal
          isOpen={openOtpModal}
          setIsOpen={setOpenOtpModal}
        />
      )} */}
    </>
  );
};

export default DoMerchantOnboard;
